import React from 'react';
import { FormSelectChoice, ExtendedFieldId, FieldId } from '@sheerid/jslib';
import { RadioComponent } from './Radio/Radio';

interface RadioGroupProps {
    onChange: any;
    options: FormSelectChoice[];
    fieldId: FieldId | ExtendedFieldId;
    className?: string;
    isErrored?: boolean;
    overrideInputClassName?: string;
    placeholder?: string;
    value?: FormSelectChoice;
}

const RadioGroup = ({
    options,
    onChange,
    className,
    fieldId,
}: RadioGroupProps) => {
    const [selectedRadio, setSelectedRadio] = React.useState(undefined);

    const getRadioOptions = () => {
        const radioOptions: JSX.Element[] = [];

        let index = 0;
        for (const option of options) {
            radioOptions.push(
                <RadioComponent
                    option={option}
                    isChecked={selectedRadio === option.value}
                    onChange={() => {
                        onChange(option);
                        setSelectedRadio(option.value);
                    }}
                    key={option.value}
                    fieldId={index === 0 ? fieldId : null}
                />,
            );
            index += 1;
        }
        return radioOptions;
    };

    return (
        <div className={`sid-radio-group ${className ? className : ''}`}>
            { getRadioOptions() }
        </div>
    );
};


export const RadioGroupComponent = RadioGroup;
